import { Badge, BadgeProps } from "ui";

export type Status = "UNPROCESSED" | "PROCESSED" | "TIME_EXPIRED" | "CLOSED";

type PaymentLinkStatusBadgeProps = {
  status: Status;
};

export default function PaymentLinkStatusBadge({
  status,
}: PaymentLinkStatusBadgeProps) {
  const { label, variant } = statusMetaMap[status];

  return <Badge variant={variant}>{label}</Badge>;
}

const statusMetaMap: Record<
  Status,
  {
    label: string;
    variant: BadgeProps["variant"];
  }
> = {
  UNPROCESSED: {
    label: "Unpaid",
    variant: "default",
  },
  PROCESSED: {
    label: "Paid",
    variant: "success",
  },
  TIME_EXPIRED: {
    label: "Expired",
    variant: "danger",
  },
  CLOSED: {
    label: "Closed",
    variant: "danger",
  },
};
